module.exports = __webpack_public_path__ + "img/DSC_9262.b8093142.jpg";